import * as React from 'react';
export const PASvg = React.forwardRef(function PASvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#F6F9FC',
        d: 'M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#EAEEF3',
        fillRule: 'nonzero',
        d: 'M2 3a1 1 0 0 0-1 1v4H0V4a2 2 0 0 1 2-2h6v1H2zm12 10a1 1 0 0 0 1-1V8h1v4a2 2 0 0 1-2 2H8v-1h6z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        fillRule: 'nonzero',
        d: 'm13.292 10.068-1.153.002a.16.16 0 0 1-.152-.11l-.358-1.098a.16.16 0 0 0-.305 0l-.356 1.097a.16.16 0 0 1-.152.11H9.662a.16.16 0 0 0-.094.291l.932.678a.16.16 0 0 1 .059.18l-.356 1.097a.16.16 0 0 0 .247.18l.933-.626a.16.16 0 0 1 .188 0l.934.626a.16.16 0 0 0 .247-.18l-.357-1.097a.16.16 0 0 1 .058-.18l.933-.678a.162.162 0 0 0-.094-.293Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#217AB7',
        fillRule: 'nonzero',
        d: 'm6.247 4.802-1.14.003a.158.158 0 0 1-.15-.11l-.353-1.084a.158.158 0 0 0-.302 0l-.351 1.084a.158.158 0 0 1-.151.11H2.66a.158.158 0 0 0-.093.286l.922.67c.055.04.079.112.057.178l-.352 1.084a.158.158 0 0 0 .245.177l.921-.618a.16.16 0 0 1 .187 0l.922.618a.158.158 0 0 0 .245-.177L5.36 5.939a.158.158 0 0 1 .057-.178l.922-.67a.16.16 0 0 0-.093-.29Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#217AB7',
        d: 'M0 8h8v6H1.998A1.993 1.993 0 0 1 0 12.002V8Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#E25950',
        d: 'M8 2h6.002C15.113 2 16 2.894 16 3.998V8H8V2Z',
      }),
    ),
  );
});
PASvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var PA = {
  category: 'flag',
  colorable: false,
  name: 'PA',
  svg: PASvg,
};
